import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { config } from '@/config.ts';

import * as Styled from './empty-state.styled';

interface EmptyStateProps {
	title?: string;
	description?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
	title,
	description
}) => {
	const { t } = useTranslation('main');

	const isNgu3 = config.BRAND === 'ngu3';
	const isCom2 = config.BRAND === 'com2';
	const isRockets = config.BRAND === 'rockets';
	const isNomad = config.BRAND === 'nomad';
	const isBlitz = config.BRAND === 'blitz';
	const sk2 = config.BRAND === 'sk2';

	const isExternalBrand = isNgu3 || isCom2 || isRockets || isNomad || isBlitz || sk2;

	const defaultTitle = title || t('nothing_here');
	const defaultDescription = description || isExternalBrand ? t('try_another_filters_no_brand') : t('try_another_filters');

	return (
		<Styled.Container>
			<Styled.Title>
				{defaultTitle}
			</Styled.Title>
			
			{defaultDescription && (
				<Styled.Description 
					dangerouslySetInnerHTML={{ __html: defaultDescription }}
				/>
			)}
		</Styled.Container>
	);
};

export default EmptyState;